import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class CargaAbonosService 
{
 
    constructor(private http: HttpClient) { }

    creaCargaMasiva(cargaMasiva: any,idUsuario:any)
    {
        let file:FormData = new FormData()    
        file.append('file', cargaMasiva.archivo, cargaMasiva.archivo.name) 
        cargaMasiva.tipoCarga="ABONOS";      
        return this.http.post(`${environment.urlApiCargas}/cargas/tipo/${cargaMasiva.tipoCarga}/usuario/${idUsuario}`, file,
        { headers: this.armaCabecera2() } ).toPromise()
    }


    creaCargaAfiliados(cargaMasiva: any,idUsuario:any)
    {
        let file:FormData = new FormData()    
        file.append('file', cargaMasiva.archivo, cargaMasiva.archivo.name) 
        cargaMasiva.tipoCarga="CARGA_AFILIADOS";      
        return this.http.post(`${environment.urlApiCargas}/cargas/tipo/${cargaMasiva.tipoCarga}/usuario/${idUsuario}`, file,
        { headers: this.armaCabecera2() } ).toPromise()
    }
    
    armaCabecera2()
    {
        return new HttpHeaders({
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}